var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 ma-0",attrs:{"fluid":""}},[_c('order-filter'),_c('order-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }